import { render } from "./File.vue?vue&type=template&id=1772a7c2"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/private/File.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1772a7c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1772a7c2', __exports__)) {
    api.reload('1772a7c2', __exports__)
  }
  
  module.hot.accept("./File.vue?vue&type=template&id=1772a7c2", () => {
    api.rerender('1772a7c2', render)
  })

}


export default __exports__